/**
 * Catalog Toolbar — sort dropdown logic.
 *
 * Two modes:
 * 1. Catalog page (data-toolbar-mode="catalog")  — JS DOM reorder within each .catalog-collection__grid
 * 2. Collection page (data-toolbar-mode="collection") — native Shopify sort_by via URL param redirect
 */

(function () {
  'use strict';

  document.querySelectorAll('[data-catalog-toolbar]').forEach(initToolbar);

  function initToolbar(toolbar) {
    var trigger = toolbar.querySelector('[data-toolbar-trigger]');
    var dropdown = toolbar.querySelector('[data-toolbar-dropdown]');
    var options = toolbar.querySelectorAll('[data-toolbar-option]');
    var mode = toolbar.getAttribute('data-toolbar-mode');

    if (!trigger || !dropdown) return;

    /* -- Toggle dropdown -------------------------------------------------- */
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      setExpanded(!expanded);
    });

    /* -- Close on click outside ------------------------------------------- */
    document.addEventListener('click', function (e) {
      if (!toolbar.contains(e.target)) {
        setExpanded(false);
      }
    });

    /* -- Close on Escape -------------------------------------------------- */
    toolbar.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        setExpanded(false);
        trigger.focus();
      }
    });

    /* -- Option click ----------------------------------------------------- */
    options.forEach(function (option) {
      option.addEventListener('click', function () {
        var value = option.getAttribute('data-toolbar-option');
        var label = option.textContent.trim();

        // Update active state
        options.forEach(function (o) {
          o.setAttribute('aria-selected', 'false');
        });
        option.setAttribute('aria-selected', 'true');

        // Update trigger label
        var labelEl = trigger.querySelector('[data-toolbar-sort-label]');
        if (labelEl) labelEl.textContent = label;

        setExpanded(false);
        trigger.focus();

        if (mode === 'collection') {
          handleCollectionSort(value);
        } else {
          handleCatalogSort(value, toolbar);
        }
      });

      // Keyboard navigation within listbox
      option.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          option.click();
        } else if (e.key === 'ArrowDown') {
          e.preventDefault();
          var next = option.nextElementSibling;
          if (next) next.focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          var prev = option.previousElementSibling;
          if (prev) prev.focus();
        }
      });
    });

    function setExpanded(state) {
      trigger.setAttribute('aria-expanded', String(state));
      dropdown.hidden = !state;

      if (state) {
        // Focus the currently selected option
        var selected = dropdown.querySelector('[aria-selected="true"]');
        if (selected) selected.focus();
      }
    }

    /* -- Collection page: redirect with sort_by param --------------------- */
    function handleCollectionSort(value) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      window.location.href = url.toString();
    }

    /* -- Catalog page: JS DOM reorder ------------------------------------- */
    function handleCatalogSort(value, toolbarEl) {
      var section = toolbarEl.closest('.catalog-body-section');
      if (!section) return;

      var grids = section.querySelectorAll('.catalog-collection__grid');
      grids.forEach(function (grid) {
        var cards = Array.from(grid.children);

        cards.sort(function (a, b) {
          switch (value) {
            case 'alpha-asc':
              return getText(a).localeCompare(getText(b));
            case 'alpha-desc':
              return getText(b).localeCompare(getText(a));
            case 'price-asc':
              return getPrice(a) - getPrice(b);
            case 'price-desc':
              return getPrice(b) - getPrice(a);
            default:
              return 0;
          }
        });

        cards.forEach(function (card) {
          grid.appendChild(card);
        });
      });
    }

    function getText(card) {
      var titleEl = card.querySelector('.product-card__title');
      return titleEl ? titleEl.textContent.trim().toLowerCase() : '';
    }

    function getPrice(card) {
      var priceEl = card.querySelector('[data-product-price]');
      if (!priceEl) return 0;
      return parseFloat(priceEl.getAttribute('data-product-price')) || 0;
    }
  }
})();
